module.exports = __webpack_public_path__ + "static/media/left_arrow.66ac18e8.svg";